<template>
  <generic-modal
    :title="$t('conversation')"
    ref="generic_modal"
    size="fullscreen"
  >
    <form>
      <div class="columns">
        <div class="column is-4">
          <div class="field">
            <generic-dropdown
              :title="$t('personality')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/assistant/personality/catalog"
              name_field="name"
              value_field="personality_id"
              @selected="personality_changed"
              ref="personality_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field" v-if="welcome_message">
            <label class="label">{{ $t("assistant") }}</label>
            <p>{{ welcome_message }}</p>
            <!-- <div class="control">
              <textarea
                class="textarea is-family-monospace"
                :placeholder="$t('welcome message')"
                v-model="welcome_message"
                readonly
              ></textarea>
            </div> -->
          </div>
        </div>
      </div>

      <div v-if="meta.messages && meta.messages.length">
        <div class="title is-6">{{ $t("messages") }}</div>
        <div
          class="box p-4 mb-2"
          :class="{
            'has-text-right': message.role === 'assistant',
          }"
          v-for="(message, index) in meta.messages"
          :key="index"
        >
          <article class="media">
            <figure class="media-left">
              <span class="icon">
                <i
                  :class="
                    message.role === 'user' ? 'fa fa-user' : 'fa fa-android'
                  "
                ></i>
              </span>
            </figure>
            <div class="media-content">
              <div class="content">
                <p>
                  <strong>{{ $t(message.role) }}</strong>
                  <br />
                  <span v-if="message.role == 'user'">{{
                    message.content
                  }}</span>
                  <span v-else-if="message.role == 'assistant'">
                    <span
                      v-html="JSON.parse(message.content).customer_response"
                    ></span>
                  </span>
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
      <div class="field has-addons">
        <div class="control is-expanded has-icons-left has-icons-right">
          <input
            class="input"
            type="text"
            :placeholder="$t('interact with assistant writing here')"
            v-model="meta.prompt"
            @keyup.enter="send_prompt"
            @keyup.esc="meta.prompt = ''"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-terminal"></i>
          </span>
        </div>
        <div class="control">
          <div class="button is-primary is-right" @click="send_prompt">
            <span class="icon is-small">
              <i class="fa fa-send"></i>
            </span>
          </div>
        </div>
      </div>
      <!-- <pre>{{ meta }}</pre> -->
      <!-- <p class="help is-success">This username is available</p>
        <div class="control">
          <input class="input" type="text" v-model="meta.prompt" />
        </div> -->
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "RequestModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {},
      error: "",
      welcome_message: this.$t("select a personality to start"),
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.personality_uuid || !v.meta.messages;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/assistant/conversation", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          if (element.personality_id)
            v.$refs.personality_dropdown.set_value(element.personality_id);
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      let data = {
        ...v.meta,
        messages: v.meta.messages,
      };
      if (!v.meta.uuid)
        put("/assistant/conversation", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/assistant/conversation", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    send_prompt() {
      let v = this;
      // if (!v.meta.uuid)
      v.$root.loader(true);
      let data = {
        ...v.meta,
        messages: v.meta.messages,
      };
      post("/assistant/conversation/chat", data)
        .then((r) => {
          v.meta.messages.push({
            role: "user",
            content: v.meta.prompt,
          });
          if (typeof r != "string") r = JSON.stringify(r);
          v.meta.messages.push({
            role: "assistant",
            content: r,
          });
          v.meta.prompt = "";
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        prompt: "",
        messages: [],
        settings: {},
      };
      v.error = "";
      v.$refs.personality_dropdown.clear();
      // v.uuid = "";
    },
    personality_changed(personality) {
      let v = this;
      if (personality) {
        v.meta.personality_uuid = personality.uuid;
        v.welcome_message = personality.first_message;
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
